import { API_STATES } from '@/helpers'

const state = {
  forgotPasswordVerificationState   : API_STATES.NOT_REQUESTED,
  forgotPasswordVerificationError   : null,
  sendLinkMessage                   : null,
  resetPasswordVerificationState    : API_STATES.NOT_REQUESTED,
  resetPasswordVerificationError    : null,
  resetPasswordMessage              : null,
  getResetPasswordVerificationState : API_STATES.NOT_REQUESTED,
  getResetPasswordVerificationError : null,
  userEmail                         : null,
  uEmail                            : null,
  uName                             : null
}

export default state
